import React, { useEffect, useMemo, useState } from 'react';
import GameLayout from './GameLayout';
import './FoodMemoryMatchGame.css';

import partyBomb from './partyBomb';

const EMOJIS = ['🍕', '🍟', '🍔', '🍩', '🍣', '🍓', '🍪', '🍦'];

function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function FoodMemoryMatchGame() {
  const [seed, setSeed] = useState(0);
  const [flipped, setFlipped] = useState([]); // indices
  const [matched, setMatched] = useState(() => new Set());
  const [moves, setMoves] = useState(0);

  const cards = useMemo(() => {
    const base = EMOJIS.slice(0, 6); // 6 pairs => 12 cards
    const deck = shuffle([...base, ...base]).map((emoji, idx) => ({ id: idx, emoji }));
    return deck;
  }, [seed]);

  const reset = () => {
    setSeed((s) => s + 1);
    setFlipped([]);
    setMatched(new Set());
    setMoves(0);
  };

  const onFlip = (i) => {
    if (matched.has(i)) return;
    if (flipped.includes(i)) return;
    if (flipped.length === 2) return;

    const next = [...flipped, i];
    setFlipped(next);

    if (next.length === 2) {
      setMoves((m) => m + 1);
      const [a, b] = next;
      const isMatch = cards[a].emoji === cards[b].emoji;
      if (isMatch) {
        setTimeout(() => {
          setMatched((m) => new Set([...m, a, b]));
          setFlipped([]);
        }, 260);
      } else {
        setTimeout(() => setFlipped([]), 520);
      }
    }
  };

  const done = matched.size === cards.length;

  useEffect(() => {
    if (done) partyBomb();
  }, [done]);

  return (
    <GameLayout
      title="Food Memory Match"
      subtitle="Match all pairs with the fewest moves."
      rightSlot={
        <div className="fmm-right">
          <span>Moves: {moves}</span>
          <button className="fmm-reset" onClick={reset}>
            Reset
          </button>
        </div>
      }
    >
      <div className="fmm-wrap">
        <div className="fmm-grid" aria-label="Memory grid">
          {cards.map((c, i) => {
            const isUp = flipped.includes(i) || matched.has(i);
            return (
              <button
                key={c.id}
                className={`fmm-card ${isUp ? 'up' : ''} ${matched.has(i) ? 'matched' : ''}`}
                onClick={() => onFlip(i)}
                aria-label={isUp ? `Card ${c.emoji}` : 'Hidden card'}
              >
                <div className="fmm-face front">{c.emoji}</div>
                <div className="fmm-face back">🍽️</div>
              </button>
            );
          })}
        </div>

        {done ? <div className="fmm-done">You matched all pairs! 🎉</div> : null}
      </div>
    </GameLayout>
  );
}
